import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export const useAuthStore = create(
  persist(
    (set, get) => ({
      user: null,
      token: null,
      isAuthenticated: false,
      selectedBusinessId: null,
      
      setAuth: (user, token) => set({ 
        user, 
        token, 
        isAuthenticated: true,
        selectedBusinessId: user?.business_ids?.[0] || null 
      }),
      
      logout: () => set({ 
        user: null, 
        token: null, 
        isAuthenticated: false,
        selectedBusinessId: null 
      }),
      
      setSelectedBusiness: (businessId) => set({ selectedBusinessId: businessId }),
      
      canViewRevenue: () => {
        const { user } = get();
        return user?.role?.can_view_revenue || false;
      },
      
      canManageUsers: () => {
        const { user } = get();
        return user?.role?.can_manage_users || false;
      },
      
      canManageBusinesses: () => {
        const { user } = get();
        return user?.role?.can_manage_businesses || false;
      },
      
      canManageRoles: () => {
        const { user } = get();
        return user?.role?.can_manage_roles || false;
      },
      
      isAdmin: () => {
        const { user } = get();
        return user?.role?.name === 'master_admin';
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({ 
        user: state.user, 
        token: state.token, 
        isAuthenticated: state.isAuthenticated,
        selectedBusinessId: state.selectedBusinessId 
      }),
    }
  )
);
